/**
  * Redirect to the homepage when the user clicks the close button in the Login Modal
  * in a not logged in area.
  */
export function redirectToHome() {
	const $container = $( '.m__user__unlogged' );
	if ( !$container.length ) {
		return;
	}
	const $closeModalButton = $container.find( '.close-modal-login' );
	const homeURL = $container.data( 'home-url' );

	$closeModalButton.on( 'click', function closeModal() {
		window.location = homeURL;
	});
}